import { defineStore } from "pinia";
import { likeApi } from "@/api";
import type { FavoriteItem, ApiResponse } from "@/api";
import { GAME_ID } from "./index";
import { clickButton } from "@/utils/point";
export const useLikeStore = defineStore("like", {
  state: () => ({}),

  actions: {
    /**
     * 点赞帖子
     */
    async addLike(target_id: number, target_type: string) {
      const response = await likeApi.add(target_id, target_type, GAME_ID);
      if (response.code == 200) {
        clickButton({
          eventType: "点赞",
          eventReason: "点赞" + (target_type == "thread" ? "帖子" : "评论"),
          eventValue: JSON.stringify({
            target_id,
            target_type,
          }),
        });
        return response;
      }
    },

    /**
     * 取消收藏帖子
     */
    async cancelLike(target_id: number, target_type: string) {
      const response = await likeApi.remove(target_id, target_type, GAME_ID);
      if (response.code == 200) {
        clickButton({
          eventType: "取消点赞",
          eventReason: "取消点赞" + (target_type == "thread" ? "帖子" : "评论"),
          eventValue: JSON.stringify({
            target_id,
            target_type,
          }),
        });
        return response;
      }
    },
  },
});
